//#region src/menu_modifier_price_display_style.ts
var MenuModifierPriceDisplayStyle = /* @__PURE__ */ function(MenuModifierPriceDisplayStyle) {
	MenuModifierPriceDisplayStyle["ShowPriceOnAllMods"] = "show-price-on-all-mods";
	MenuModifierPriceDisplayStyle["ShowPriceInHeader"] = "show-price-in-header";
	return MenuModifierPriceDisplayStyle;
}(MenuModifierPriceDisplayStyle || {});
//#endregion
export { MenuModifierPriceDisplayStyle };

//# sourceMappingURL=menu_modifier_price_display_style.js.map